module.exports = __webpack_public_path__ + "img/ic-rejected2.1b968a88.svg";